import React, {Component} from 'react';
import Main from '../../components/smart/Main';
import MainMessage from '../../components/smart/MainMessage';
import Logo from '../Logo.png';
import FloatContainer from '../../components/dummy/FloatContainer';
import VisionReForm from '../../utils/Forms/VisionReimbursementForm.pdf';
import Login from '../../components/dummy/Login';

class MembersPage extends Component {
    componentDidMount() {
        if(this.props.ProviderSearch) {
            if(this.props.ProviderSearch === "dental") {
                console.log('hit');
                window.history.replaceState({ProviderSearch: false}, "members", "/members");
                setTimeout(()=> {window.location.href = "https://www.cachepremier.com/provider_search"},30);
            } else {
                window.history.replaceState({ProviderSearch: false}, "members", "/members");
                setTimeout(()=> {window.location.href = "https://www.custom-health.net/townandcountry/search.php"},30);
            }

            // window.history.replaceState({ProviderSearch: false}, "members", "/members");
            // window.history.pushState({ProviderSearch: false}, "members", "/members");
            // window.location.assign("/members");

            // console.log(window.history);
            // setTimeout(()=> {window.location.href = "https://www.cachepremier.com/provider_search"},40)
            // window.location = "https://www.cachepremier.com/provider_search";
        } 
        
    }
    
    render() {
        return(
                <Main>
                    <h3 className="Main_Title">Already a Member?</h3>
                    <ul style={{listStyleType: "none"}}>
                        <li>Log in to check claim status</li>
                        <li>View/Print explanations of benefits</li>
                        <li>Print temp ID cards</li>
                        <li>View benefit accumulators</li>
                    </ul>
                    <Login Page="Member" URL="https://www.cachepremier.com/member/member_login" ID="UserName" Key="Password" ID_Key="login_id" Key_Key="password"></Login>
                    <p className="Main_Description" style={{width:"60%", margin:"auto", paddingBottom:"10px", paddingTop:"10px"}}>The options below don't require a login</p>
                    
                    <FloatContainer>
                        <div className="Float_Content_Centered">
                            <h4>Looking for a provider in network?</h4>
                            <ul style={{listStyleType: "none", padding: "0"}} >
                                <li>
                                    <a href="https://www.cachepremier.com/provider_search" target="_blank" rel="noopener noreferrer">Dental Provider Search</a>
                                </li>
                                <li>
                                    <a href="http://www.custom-health.net/townandcountry/search.php" target="_blank" rel="noopener noreferrer">Medical Provider Search</a>
                                </li>
                            </ul>
                        </div>

                        <div className="Float_Content_Centered">
                            <h4>Request an ID card or some help?</h4>
                            <ul style={{listStyleType: "none", padding: "0"}} >
                                <li>
                                    <a href="https://basbenefits.com/#34722e0a-8bc7-4260-9d57-c3ceeb0d11e9" target="_blank" rel="noopener noreferrer">Request Assistance</a>
                                </li>
                                <li>
                                    <a href="https://basbenefits.com/members/#e8926c0a-6a87-41a8-bc40-9f80d60b2d08" target="_blank" rel="noopener noreferrer">Request ID Cards</a>
                                </li>
                            </ul>
                        </div>
                        <div className="Float_Content_Centered">
                            <h4>Looking for a form?</h4>
                            <ul style={{listStyleType: "none", padding: "0"}} >
                                <li>
                                    <a href={VisionReForm} target="_blank" rel="noopener noreferrer" >Vision Reimbursement Form</a>
                                </li>
                                <li>
                                    <a href="https://www.cachepremier.com/docs" target="_blank" rel="noopener noreferrer">All Forms & Documents</a>
                                </li>
                               
                            </ul>
                        </div>
                    </FloatContainer>
                    <hr></hr>   
                    <h3 className="Main_Title">Why Become a Member?</h3>

                    <MainMessage>
                                        <div className="Main_Message_Content">
                                            <p>
                                            Our main driving force at Matrix Healthcare is to offer simplified benefits to our members and their families.  
                                            We have worked hard to provide access to Utah’s top professional providers at an affordable cost, passing the savings onto you.
                                            <br></br>
                                            Our services are administered through <a target="_blank" rel="noopener noreferrer" href="https://basbenefits.com/members">BAS Benefits</a> where representatives are eager to assist you with any questions you may have! 
                                            </p>
                                        </div>
                                        <div className="Main_Message_Logo_Box">
                                            <img src={Logo} alt="Logo"></img>
                                        </div>  
                    </MainMessage>
                    
                   
                </Main>
        )
    }
}

export default MembersPage;